<template>
    <div class="details-pop" v-if="itemObj">
        <el-row :gutter="0">
            <el-col :span="24">
                <div class="">{{ itemObj.name }}</div>
            </el-col>
            <el-col :span="12" class="details-item">
                <div class="txt-label">{{ $t('hezhang.index.leftAside.collectPhotos') }}</div>
                <div class="txt-value">{{ itemObj.statistics ? itemObj.statistics[0].value : '--' }}</div>
            </el-col>
            <el-col :span="12" class="details-item">
                <div class="txt-label">
                    {{ $t('hezhang.index.leftAside.suspectedIncidentAwaitingProcessing') }}
                </div>
                <div class="txt-value">{{ itemObj.statistics ? itemObj.statistics[3].value : '--' }}</div>
            </el-col>
            <!-- 河道 -->
            <template v-if="itemObj.type == 'RIVER'">
                <el-col :span="12" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.length') }}</div>
                    <div class="txt-value">{{ itemObj.length || '--' }} km</div>
                </el-col>
                <el-col :span="12" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.averageWidth') }}</div>
                    <div class="txt-value">{{ itemObj.width || '--' }} m</div>
                </el-col>
            </template>

            <el-col :span="12" class="details-item" v-if="itemObj.type !== 'RIVER'">
                <div class="txt-label">{{ $t('hezhang.index.leftAside.area') }} </div>
                <div class="txt-value">{{ itemObj.coverageArea || '--' }} m²</div>
            </el-col>

            <el-col :span="12" class="details-item" v-if="itemObj.type == 'RIVER' || itemObj.type == 'LAKE'">
                <div class="txt-label">{{ $t('hezhang.index.leftAside.averageDepth') }}</div>
                <div class="txt-value">{{ itemObj.dept || '--' }} m</div>
            </el-col>
            <template v-if="itemObj.type">
                <el-col :span="12" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.townLevelRiverChief') }}</div>
                    <div class="txt-value">{{ itemObj.townChiefName || '--' }}</div>
                </el-col>
                <el-col :span="12" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.villageLevelRiverChief') }}</div>
                    <div class="txt-value">{{ itemObj.villageChiefName || '--' }}</div>
                </el-col>
            </template>

            <!-- 工程 -->
            <template v-else>
                <el-col :span="12" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.belongingRiverChannel') }}</div>
                    <div class="txt-value">{{ itemObj.riverName || '--' }}</div>
                </el-col>
                <el-col :span="24" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.constructionName') }}</div>
                    <div class="txt-value">{{ itemObj.constructionName || '--' }}</div>
                </el-col>
                <el-col :span="24" class="details-item">
                    <div class="txt-label">
                        {{ $t('hezhang.index.leftAside.contactPhone') }}
                    </div>
                    <div class="txt-value">{{ itemObj.contactPhone || '--' }}</div>
                </el-col>
                <el-col :span="24" class="details-item">
                    <div class="txt-label">{{ $t('hezhang.index.leftAside.constructionCertificate') }}</div>
                    <div class="txt-value">{{ itemObj.name || '--' }}</div>
                </el-col>
            </template>
        </el-row>
        <div class="details-view">
            <el-button plain size="mini" class="btn-view" @click="bindView(itemObj)">{{
                $t('common.btnView')
                }}</el-button>
        </div>
    </div>
</template>

<script>
/**
 * @description 河湖岛列表项
 * @example
 *
 * @param {Object} data 事件数据
 * emit: click 点击事件回调
 */
export default {
    name: 'hzItemDetailsPop',
    inject: {
        searchForm: {
            default: () => ([]), // 默认空对象，防止undefined
        },
    },
    components: {},
    props: {
        itemObj: {
            type: Object,
            default: () => ({}),
        },
    },

    data () {
        return {};
    },
    computed: {},
    methods: {
        bindView (item) {
            // 直接通过可选链访问，不存在时返回undefined
            let quertDate = this.searchForm?.queryDate || JSON.parse(this.$route.query?.queryDate) || [];
            this.$router.push({
                path: '/hezhang/dailypatrol',
                query: {
                    dataId: item.id,
                    type: item.type,
                    queryDate: JSON.stringify(quertDate), // 关键：将数组转为JSON字符串，避免路由自动序列化为对象
                },
            });
        },
    },
    watch: {},
    created () { },
    mounted () { },
};
</script>

<style lang="scss" scoped>
.details-pop {
    max-width: 450px;

    .details-item {
        display: flex;

        .txt-label {
            color: #c7c7c7;
        }

        .txt-value {
            margin-left: 15px;
        }
    }

    .details-view {
        text-align: center;
        margin-top: 10px;

        .btn-view {
            width: 50%;
            background: #112d7b;
            border: 1px solid #1a47a4;
            color: white;
        }
    }
}
</style>
